import { Button } from '@/components/ui/button';

export function PerItemSaveActions(props: {
  error?: string | null;
  saving?: boolean;
  canSave?: boolean;
  saveLabel: string;
  onDelete?: () => void;
  onSave?: () => void;
}) {
  const { error, saving = false, canSave = false, saveLabel, onDelete, onSave } = props;

  return (
    <div className="flex min-w-0 items-center gap-2">
      {/* Error grows LEFT */}
      {error ? (
        <div className="text-destructive min-w-0 flex-1 text-right text-xs break-words whitespace-normal">{error}</div>
      ) : (
        <div className="flex-1" />
      )}

      {/* Buttons never shrink */}
      {onDelete ? (
        <Button variant="outline" size="sm" onClick={onDelete} disabled={saving} className="shrink-0">
          Delete
        </Button>
      ) : null}

      {onSave ? (
        <Button size="sm" onClick={onSave} disabled={!canSave || saving} className="shrink-0">
          {saveLabel}
        </Button>
      ) : null}
    </div>
  );
}
